class FilterBar extends HTMLElement {
  constructor() {
    super();

    this.header = this.querySelector("header");
    this.footer = this.querySelector("footer");
    this.inner = this.querySelector('[id="FilterBar-Inner"]');
    this.toggleWrapper = this.querySelector('[id="FilterBar-Toggle-Wrapper"]');
    this.facetItems = this.querySelectorAll("facet-item");
    this.toggleButtons = document.querySelectorAll(
      `[data-open="FilterBar-${this.dataset.sectionId}"]`
    );

    this.init();
    this.registerEvents();
  }

  reInit() {
    this.init();
  }

  init() {
    if (this.isOverflowing() === true) {
      this.toggleWrapper.classList.add("is-overflowing");
    } else {
      this.toggleWrapper.classList.remove("is-overflowing");
    }
  }

  registerEvents() {
    this.header.addEventListener("click", this.onToggleButtonClick.bind(this));
    this.footer.addEventListener("click", this.onToggleButtonClick.bind(this));
    this.toggleButtons.forEach((button) => {
      button.addEventListener("click", this.onToggleButtonClick.bind(this));
    });
    window.addEventListener(
      "resize",
      throttle(() => {
        this.init();
      }, 250),
      { passive: true }
    );
  }

  isOverflowing() {
    return this.inner.clientWidth < this.inner.scrollWidth;
  }

  onToggleButtonClick(event) {
    event.preventDefault();
    this.toggleAttribute("open");
    if (this.hasAttribute("open")) {
      if (window.innerWidth < 768) {
        document.documentElement.classList.add("overflow-hidden");
      }
    } else {
      this.facetItems.forEach((el) => el.close());
      if (window.innerWidth < 768) {
        document.documentElement.classList.remove("overflow-hidden");
      }
    }
  }
}
customElements.define("filter-bar", FilterBar);
